<span class="status-circle {{status}} status--{{progress}}"></span>
